//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import onResize from '~/directives/resize'
import AccountIcon from '~/assets/img/account.svg?inline'

export default {
  name: 'AppMobileNav',

  directives: {
    resize: onResize
  },

  components: {
    AccountIcon
  },

  props: {
    menu: {
      type: String,
      default: 'menu'
    }
  },

  data() {
    return {
      showLogin: false
    }
  },

  computed: {
    ...mapGetters('user', ['isUser', 'isSubscriber', 'getUserStatus']),

    cta() {
      switch (this.getUserStatus) {
        case 'guest':
          return { url: '/get_started', label: 'Get Started + Over 50% Off*' }
        case 'user':
          return { url: '/recommendations', label: 'Recommendations + Over 50% Off*' }
        default:
          return null
      }
    },

    subscriberMenuItems() {
      return [
        {
          label: 'My Account',
          items: [
            {
              label: 'Account Overview',
              url: '/my_account'
            },
            {
              label: 'Report & Tips',
              url: '/my_account/nutrition-report'
            },
            {
              label: 'My Routine',
              url: '/my_account/routine'
            },
            {
              label: 'Orders & Tracking',
              url: '/my_account/order-history'
            },
            {
              label: 'Info & Shipping',
              url: '/my_account/customer'
            }
          ]
        }
      ]
    },

    menuItems() {
      return [
        {
          label: 'Science',
          url: '/science'
        },
        {
          label: 'Products',
          url: '/products'
        },
        {
          label: 'Shop By Concern',
          items: [
            {
              label: 'Skin',
              url: '/products/category/skin'
            },
            {
              label: 'Hair',
              url: '/products/category/hair'
            },
            {
              label: 'Body',
              url: '/products/category/body'
            },
            {
              label: 'Mood',
              url: '/products/category/mood'
            },
            {
              label: 'Immunity',
              url: '/products/category/immunity'
            }
          ]
        },
        {
          label: 'Our Nutritionists',
          url: '/nutritionists'
        },
        {
          label: 'Sustainability',
          url: '/sustainability'
        },
        {
          label: 'The Wellnest Blog',
          url: 'https://www.humnutrition.com/blog'
        },
        {
          label: 'Help Center',
          url: 'https://help.humnutrition.com'
        }
      ]
    }
  },

  watch: {
    $route() {
      this.$emit('close')
    }
  },

  mounted() {
    document.body.style.setProperty('height', '100vh')
    document.body.style.setProperty('overflow', 'hidden')
    document.body.style.setProperty(
      'padding-right',
      window.innerWidth - document.documentElement.offsetWidth + 'px'
    )

    this.handleResize()

    setTimeout(() => {
      if (window.zE) window.zE('webWidget', 'hide')
    }, 0)
  },

  beforeDestroy() {
    document.body.style.removeProperty('height')
    document.body.style.removeProperty('overflow')
    document.body.style.removeProperty('padding-right')

    this.$bus.$emit('zendesk:toggle')
  },

  methods: {
    handleResize() {
      const scrollY =
        30 - window.scrollY >= 0 && !this.isSubscriber ? 30 - window.scrollY : 0
      const vh = window.innerHeight * 0.01
      document.documentElement.style.setProperty('--vh', `${vh}px`)
      document.documentElement.style.setProperty('--scroll-y', `${scrollY}px`)
    }
  }
}
